import {IListNamesResolver} from '@src/@interfaces/services/NameResolvers/IListNamesResolver';

export default class ListNamesResolver implements IListNamesResolver {
    protected nameMutator?: (name: string) => string = undefined;

    getUniqueName(controllerName: string): string {
        return this.resolveName(controllerName, '--list-of-records');
    }

    getSearchTermGetParamName(controllerName: string): string {
        return this.getSearchTermGetParamNameByListUniqueName(this.getUniqueName(controllerName));
    }

    getPageNumberGetParamName(controllerName: string): string {
        return this.getPageNumberGetParamNameByListUniqueName(this.getUniqueName(controllerName));
    }

    getSearchTermGetParamNameByListUniqueName(listUniqueName: string): string {
        return this.resolveName(listUniqueName, '-search-term');
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getDisableFilteringGetParamNameByListUniqueName(listUniqueName: string): string {
        return 'without-filters';
    }

    getPageNumberGetParamNameByListUniqueName(listUniqueName: string): string {
        return this.resolveName(listUniqueName, '-page-number');
    }

    resolveName(controllerName: string, key: string): string {
        const result = `${controllerName}${key}`;

        return this.nameMutator ? this.nameMutator(result) : result;
    }

    withNameMutator<T>(
        mutator: null | undefined | ((name: string) => string),
        callback: (service: IListNamesResolver) => T,
    ): T {
        try {
            this.nameMutator = mutator ?? undefined;
            return callback(this);
        } finally {
            this.nameMutator = undefined;
        }
    }
}
